import React, { useState } from "react";
import { ShieldCheck, X } from "lucide-react";
import { useAuth } from "../lib/auth";

const KEY = "stargrid_claim_nudge_dismissed";

// Guests (passwordless start) can secure their account with Google so they can log back in anywhere.
export default function ClaimAccountNudge() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  const isGuest = user && !user.email_verified && (user.auth_methods || []).includes("guest") && !(user.auth_methods || []).includes("google");
  if (!isGuest || hidden) return null;

  const claim = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  const dismiss = () => { sessionStorage.setItem(KEY, "1"); setHidden(true); };

  return (
    <div className="mb-5 glass rounded-xl border border-[#C8A96E]/40 px-4 py-3 sm:px-5 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="claim-account-nudge">
      <div className="w-9 h-9 rounded-full bg-[#C8A96E]/15 border border-[#C8A96E]/40 flex items-center justify-center shrink-0">
        <ShieldCheck size={16} className="text-[#C8A96E]" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm text-white font-medium">Secure this account so you can log back in from any device</div>
        <div className="text-[11px] text-[#A89C98] mt-0.5">
          One tap with Google — use the same email, <span className="text-[#E8DFD3]" data-testid="claim-account-email">{user.email}</span>, and your blueprint, scans and purchases stay with you.
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          onClick={claim}
          data-testid="claim-account-btn"
          className="inline-flex items-center gap-2 h-9 px-4 uppercase tracking-widest text-[10px] font-bold bg-[#C8A96E] text-[#15111A] hover:bg-[#A98B55] transition-colors"
        >
          <ShieldCheck size={12} /> Secure with Google
        </button>
        <button onClick={dismiss} aria-label="Dismiss" data-testid="claim-account-dismiss" className="p-2 text-[#A89C98] hover:text-white transition-colors">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
